let iso;
const masonryGrid = document.querySelector('.masonry');
const initMasonry = () => {
    const elementsArray = document.querySelectorAll('.masonry .masonry-item');
    if (masonryGrid && elementsArray) {
        iso = new Isotope(masonryGrid, {
            // options
            itemSelector: '.masonry-cell',
            layoutMode: 'masonry',
            masonry: {
                gutter: 30,
                // @ts-ignore
                horizontalOrder: true
            }
        });
        reloadMasonry(masonryGrid, iso);
    }
};
const reloadMasonry = (element, isotope) => {
    imagesLoaded(element).on('progress', () => {
        // layout Isotope after each image loads, to avoid layout collapsing
        isotope.layout();
    });
};
